var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10507_56526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8425 0.650024C15.7515 0.560024 15.6255 0.5 15.486 0.5H11C10.7235 0.5 10.5 0.725 10.5 1C10.5 1.275 10.7235 1.5 11 1.5H14.3145L8.91499 6.90002L9.62199 7.60498L15.0155 2.21002L15 5.5C15 5.775 15.2235 6 15.5 6C15.7765 6 16 5.775 16 5.5V1C16 0.85 15.939 0.730024 15.8425 0.650024ZM6.37801 9.39502L0.984497 14.79L1 11.5C1 11.225 0.7765 11 0.5 11C0.2235 11 0 11.225 0 11.5V16C0 16.15 0.0610012 16.27 0.157501 16.35C0.248501 16.44 0.374508 16.5 0.514008 16.5H5C5.2765 16.5 5.5 16.275 5.5 16C5.5 15.725 5.2765 15.5 5 15.5H1.6855L7.08501 10.1L6.37801 9.39502Z",
    fill: "#0F314D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10507_56526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailHoverIcon);
export default __webpack_public_path__ + "static/media/emailHoverIcon.7dcfe789daedc5ab56cc10ea6d3e75a6.svg";
export { ForwardRef as ReactComponent };